export const INVALID_EMAIL_MESSAGE =
  "Digite um e-mail válido, como nome@exemplo.com.";

export const SUCCESS_TITLE = "Confira seu e-mail";

export const SPAM_NOTE =
  "Não chegou? Veja a caixa de spam ou peça de novo em alguns minutos.";

export const SEND_FAILURE_MESSAGE =
  "Não conseguimos enviar agora. Tente de novo em alguns minutos.";

const RESET_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** The view calls this before AuthorizationService.forgotPassword. */
export function isResetEmail(value: string): boolean {
  return RESET_EMAIL.test(value.trim());
}

/**
 * What the page may show after POST /auth/forgot-password.
 * 200 is the same body whether or not the account exists.
 * 500 happens only after the account was found (the token or the mail failed),
 * so it uses the same sent sentence and does not reveal the account.
 * 400 is an address the server rejected. Any other status can be retried.
 */
export type ResetRequestOutcome = "sent" | "invalid" | "retry";

export function resetRequestOutcome(status: number | undefined): ResetRequestOutcome {
  if (status !== undefined && status >= 200 && status < 300) return "sent";
  if (status === 400) return "invalid";
  if (status === 500) return "sent";
  return "retry";
}

/** Shown after a sent outcome. Ignores the API message. Does not say the account was found. */
export function resetSentSentence(email: string): string {
  const trimmed = email.trim();
  return `Se houver uma conta com ${trimmed}, você vai receber um link para criar uma senha nova.`;
}
